import React from "react";

const OurGoal = () => {
  // const sideImg = [
  //   {
  //     img: "./img/about/who-2.png",
  //     caption: "End poverty by uplifting and valuing our skilled labour force",
  //   },
  //   {
  //     img: "./img/about/who-1.png",
  //     caption: "Empower women to empower society",
  //   },
  //   {
  //     img: "./img/about/who-3.png",
  //     caption: "Build a better future for women—build a better future for all",
  //   },
  //   {
  //     img: "./img/about/who-4.png",
  //     caption: "Ensure financial stability for every household",
  //   },
  // ];

      const data = [
    {
      img: "/img/goals/uplifting.png",
      title: "End poverty by uplifting and valuing skilled labour",
    },
    { img: "/img/goals/women.jpg", 
      title: "Empower women to build a stronger, inclusive society" },
    {
      img: "/img/goals/secure.jpg",
      title: "Create opportunities to secure women’s future",
    },
    {
      img: "/img/goals/financial.jpg",
      title: "Ensure financial stability for every Indian household",
    },
    {
      img: "/img/goals/joyful.jpg",
      title: "Build a joyful, disease-free, and poverty-free nation",
    },
  ];

  return (
    <>
      <div className="container">
        <section className="row  row-cols-1 row-cols-md-2 py-5">
          <article className="col">
            <h2 className="text-black fw-bold display-3 my-3">
              OCFIT <span style={{color:"#FE7743"}} className="fw-semibold">Goals</span>
            </h2>
            <h3 style={{color:"#FE7743",textTransform:"uppercase"}}>OCFIT GOALS for a Stronger India</h3>
            <p style={{ fontSize: "18px",textAlign:"justify" }} className=" fs-5 col-md-11">
              Our CEO Ms Vandana Sabharwal is big supporter of women empowerment
              and people with special abilities PWD . She is very actively
              involved in management of Blind School n also works with old age
              home in Gurugram.
            </p>

            <p style={{ fontSize: "18px",textAlign:"justify" }} className=" fs-5 col-md-11">
              At OCFIT, our primary goal is to empower rural youth through
              comprehensive skill development and vocational training. We aim to
              bridge the gap between traditional education and industry demands
              by offering state-of-the-art training programs. Our objectives
              include enhancing employability, fostering entrepreneurial spirit,
              and creating sustainable career pathways for our students. We are
              committed to collaborating with industry leaders and government
              bodies to continuously update our curriculum and provide hands-on
              experience. By focusing on practical skills and real-world
              applications, we strive to uplift communities and drive economic
              growth through meaningful employment opportunities.
            </p>
          </article>
          <aside className="col row row-cols-1 row-cols-md-2 py-3 m-0 justify-content-center">
            {data?.map((item, idx) => (
              <div key={idx} className="col ">
                <figure className="position-relative p-0 awards_card">
                  <img src={item?.img} style={{height:"100%",objectFit:"cover"}} className="rounded"/>
                  <figcaption
                    style={{ bottom: "30px", left: "10px" }}
                    className="position-absolute text-white fs-5 fw-semibold left-0 col-10 pe-md-3 "
                  >
                    {item?.title}
                  </figcaption>
                </figure>
              </div>
            ))}
          </aside>
        </section>
      </div>
    </>
  );
};

export default OurGoal;
